module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home-pc"
    }
  }, [_c('div', {
    staticClass: "header-wrap",
    attrs: {
      "id": "header-wrap-id"
    }
  }, [_c('a', {
    attrs: {
      "id": "s-summary"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }],
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-summary"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#past-guest"
    }
  }, [_vm._v("往期嘉宾")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-guest"
    }
  }, [_vm._v("邀请嘉宾")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-agenda"
    }
  }, [_vm._v("大会议程")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-award"
    }
  }, [_vm._v("奖项评选")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-tickets"
    }
  }, [_vm._v("参会购票")])]), _vm._v(" "), (false) ? _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.ticketUrl,
      "target": "_blank"
    }
  }, [_vm._v("参会购票")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-partners"
    }
  }, [_vm._v("合作机构")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": "#s-contact-us"
    }
  }, [_vm._v("联系我们")])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "intro-content"
  }, [_vm._m(0), _vm._v(" "), (false) ? _c('div', {
    staticClass: "intro-bold"
  }, [_vm._v(" TRUST 相信，相信的力量！")]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "guest-bg-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-guest"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section guest",
    attrs: {
      "id": "guest-wrap-id"
    }
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "guest-list"
  }, _vm._l((_vm.guestList), function(guest, index) {
    return _c('li', [_c('div', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "left-top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": guest.photo,
        "alt": "嘉宾"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-bottom"
    }, [_c('div', {
      staticClass: "g-name"
    }, [_vm._v(" " + _vm._s(guest.name) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "g-title"
    }, [_vm._v(" " + _vm._s(guest.position) + " ")])])])])
  }), 0)])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "section past-guest",
    attrs: {
      "id": "past-guest"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-past-guest"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "agenda-bg-area"
    }
  }, [_c('div', {
    staticClass: "section agenda"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "agenda-title-bottom"
  }), _vm._v(" "), _vm._l((_vm.agendaData.type[0]), function(type, index) {
    return [_c('div', {
      class: 'agenda-group-' + index
    }, [_c('div', {
      staticClass: "agenda-group-center",
      class: 'agenda-group-center-' + index
    }, [_c('div', {
      staticClass: "conf-host",
      class: 'agenda-theme-' + index
    }, [(false) ? _c('div', {
      staticClass: "which-conf"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(type)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "see-map",
      attrs: {
        "href": "http://j.map.baidu.com/h4z9P",
        "target": "_blank"
      }
    }, [_vm._v("查看地图")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "agenda-list"
    }, [_vm._l((_vm.agendaData.meeting[type]), function(agenda, index) {
      return [_c('agenda-item', {
        attrs: {
          "data": agenda,
          "type": type,
          "index": index
        }
      })]
    })], 2)])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "time-address"
  }, [_vm._v("时间：2020年11月26日         地点：中国北京·千禧大酒店二层大宴会厅")])], 2)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    attrs: {
      "id": "partners-bg-area"
    }
  }, [_c('div', {
    staticClass: "section partners"
  }, [_c('p', {
    attrs: {
      "id": "s-partners"
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('dl', [_vm._l((_vm.partnerList), function(partner) {
    return [_vm._l((partner), function(val, key) {
      return [_c('dt', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('dd', _vm._l((val), function(pic) {
        return _c('img', {
          attrs: {
            "src": pic.logo + '-fintech.partner'
          }
        })
      }), 0)]
    })]
  })], 2)])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "section about-us"
  }, [_c('p', {
    attrs: {
      "id": "s-contact-us"
    }
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "about-us-wrap"
  }, [_vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), (false) ? _c('div', {
    staticClass: "qrcode"
  }, [_c('img', {
    attrs: {
      "src": "https://www.xfz.cn/static/build/images/xfz-school-wechat-share.png"
    }
  }), _vm._v(" "), _vm._m(18)]) : _vm._e()])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "bottom-buy-link-float"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-scroll": "",
      "data-options": "{ \"easing\": \"easeInQuad\" }",
      "href": _vm.newsUrl,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f-pc/live-logo.png")
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-normal"
  }, [_vm._v("\n            小饭桌青年创业者大会此前已成功举办四届，是创投圈TOP级别的年度盛宴。第5届小饭桌青年创业者大会以“乘风破浪，逆风而行”为主题，聚焦创投圈，关注新风向，深度剖析全年新经济发展态势，预见下一年机会所在，是一场属于创业者和投资人的盛会。\n            "), _c('br'), _c('br'), _vm._v("\n            在不确定的市场寻找确定性的机会\n            "), _c('br'), _c('br'), _vm._v("\n            在没有英雄主义的时代选出推动经济变革的英雄\n            "), _c('br'), _c('br'), _vm._v("\n            好风凭借力，送我上青云，小饭桌与你一起预见2021\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("已邀嘉宾")]), _vm._v(" "), _c('span', {
    staticClass: "tip"
  }, [_vm._v("按出场顺序排")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh"
  }, [_vm._v(" 往期嘉宾")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5069.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/e-wap/jim.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": require("../assets/e-wap/play.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5072.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/e-wap/zhangying.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": require("../assets/e-wap/play.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/5078.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/e-wap/tuobuhua.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": require("../assets/e-wap/play.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1897.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/e-wap/qasar.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": require("../assets/e-wap/play.png")
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.bufanbiz.com/post/1916.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/e-wap/xiaowenjie.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "play-btn",
    attrs: {
      "src": require("../assets/e-wap/play.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section agenda-2"
  }, [_c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("大会议程")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static-miniapp.xfz.cn/2019-agenda-2.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agenda-top"
  }, [_c('p', {
    attrs: {
      "id": "s-agenda"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("大会议程")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "award-area"
    }
  }, [_c('p', {
    attrs: {
      "id": "s-award"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section award"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("奖项评选")])])]), _vm._v(" "), _c('div', {
    staticClass: "award-list-wrap"
  }, [_c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/gy0mOM"
    }
  }, [_vm._v("2020年度准独角兽企业TOP 30")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/o0V6w5"
    }
  }, [_vm._v("2020年度 30 under 30 新锐投资人 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/ZaCdGH"
    }
  }, [_vm._v("2020年度新消费领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/g3u3PY"
    }
  }, [_vm._v("2020年度企业服务领域新锐投资人TOP 10 ")]), _vm._v(" "), _c('a', {
    staticClass: "award-item",
    attrs: {
      "target": "_blank",
      "href": "https://jinshuju.net/f/P5EOnU"
    }
  }, [_vm._v("2020年度工业互联网领域新锐投资人TOP 10")])]), _vm._v(" "), _c('div', {
    staticClass: "award-content"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "participator-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("参会人群分析")])])]), _vm._v(" "), _c('div', {
    staticClass: "participator-content"
  }, [_c('div', {
    staticClass: "partici-img"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tickets-bg-area"
    }
  }, [_c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("参会购票")])])]), _vm._v(" "), _c('a', {
    staticClass: "tickets-content",
    attrs: {
      "href": "https://www.huodongxing.com/event/1567573387600",
      "target": "_blank"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section tickets"
  }, [_c('p', {
    attrs: {
      "id": "s-tickets"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("往届回顾")])])]), _vm._v(" "), _c('div', {
    staticClass: "old-version"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2019/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/bufan2018/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2017/"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.xfz.cn/explore/xfz2016/"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faq-bg-area"
    }
  }, [_c('div', {
    staticClass: "section faq"
  }, [_c('p', {
    attrs: {
      "id": "s-faq"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("FAQ-参会指南")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "faq-item"
  }, [_c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票什么时候截止?\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票截止日期为 2020年11月25日，中午12:00\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            购票付款成功后，如何获得参会凭证？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            在您成功付款后，您将收到短信提醒，内容包含参会信息及电子票二维码，活动时凭电子票二维码入场。"), _c('br'), _vm._v("活动开始前一周，还会短信发送一次参会信息。如果您关注了小饭桌微信公众号，届时也会有相应提醒。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            观众座位是否有预留？会议现场是否需要对号入座，会议中途离开，座位是否保留？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            请您核对票务权益，限量体验票、早鸟票用户根据进场顺序安排，不确保坐席，如您中途离开会场，不确保保留座位。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-q"
  }, [_c('span', [_vm._v("Q:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            大会场馆附近有就餐的地方吗？\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('span', [_vm._v("A:")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                            酒店1层设有自助餐厅；距会场2-5分钟，步行即可到达诸多卖场，中餐、西餐、港式餐厅等，价位不等，有多样选择。\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-a"
  }, [_c('div', {
    staticClass: "sa-title"
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('div', {
    staticClass: "sa-content"
  }, [_vm._v("\n                            1) 大会门票仅为“999元”票档开具增值税普通发票，不提供增值税专用发票；"), _c('br'), _vm._v("\n                            2) 开票内容为：会议服务费； "), _c('br'), _vm._v("\n                            3) 因本公司每月增值税普通发票数量有限，将以申请开票的先后顺序开具并安排快递，不保证当月开票，请谅解。"), _c('br')])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("合作机构")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section location"
  }, [_c('p', {
    attrs: {
      "id": "s-location"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("会议地址")])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "location-wrap"
  }, [_c('div', {
    staticClass: "address-info"
  }, [_c('div', [_vm._v("\n                        地铁10号线：金台夕照站 A口出，西行420米即到\n                    ")]), _vm._v(" "), _c('div', [_vm._v("\n                        自驾：北京市朝阳区东三环中路七号，千禧大酒店\n                    ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://j.map.baidu.com/22/en",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/f-pc/map.png"),
      "alt": ""
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-title"
  }, [_c('div', {
    staticClass: "zh-wrap"
  }, [_c('span', {
    staticClass: "zh"
  }, [_vm._v("联系我们")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("市场合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("媒体合作")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("罗阳-Rick")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("188-1179-5758")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("luoyang@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名咨询")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("白怡-Nina")]), _vm._v(" "), _c('div', {
    staticClass: "phone"
  }, [_vm._v("159-0133-7648")]), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_vm._v("baiyi@xfz.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qrcode-info"
  }, [_c('span', [_vm._v("扫描二维码"), _c('br'), _vm._v(" 关注小饭桌")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-261aa552"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePc.vue
// module id = 28
// module chunks = 0